import styled from "styled-components";

export const MyModalCloseButton = styled.button`
        float: right;
        background: none;
        border: none;
        font-size: large;
        color: darkslategrey;

        &:hover {
            text-decoration: none;
            font-weight: bold;
        }
`

export const MyModalForm = styled.form`
    margin-top: 1em;
`

export const MyModalContentRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 36.5em;
    justify-content: flex-end;
`

export const MyModalContentTextInput = styled.input.attrs({ type: "text"})`
    width: 25em;
    margin-left: 1em;

    &.changed {
        background: rgb(175, 238, 238);
    }
`

export const MyModalContentNumberInput = styled.input.attrs({ type: "number"})`
    width: 25em;
    margin-left: 1em;

    &.changed {
        background: rgb(175, 238, 238);
    }
`

export const MyModalContentDateInput = styled.input.attrs({ type: "date"})`
    width: 25em;
    margin-left: 1em;

    &.changed {
        background: rgb(175, 238, 238);
    }
`

export const MyModalContentSelectInput = styled.select`
    width: 25.5em;
    margin-left: 1em;

    &.changed {
        background: rgb(175, 238, 238);
    }
`
export const MyModalContentSelectInputOption = styled.option`
    &.origin {
        font-weight: bold;
    }
`
export const MyModalButtons = styled.div`
    display: flex;
    padding: 1em;
    justify-content: space-between;
`
